import { asyncActionsCreator } from '../../global/redux';
import * as constants from './constants';

export const getOrderHistory = asyncActionsCreator(constants.GET_ORDER_HISTORY);
